// extracted by css-extract-rspack-plugin
export default {"trigger":"trigger-oVAcIl","itemSelected":"itemSelected-n9I1IZ","menuList":"menuList-lEa4hY"};